export const einaRegular = 'Eina04-Regular'
export const einaSemiBold = 'Eina04-SemiBold'
export const einaLight = 'Eina04-Light'
export const konnectRegular = 'Konnect-Regular'
export const konnectSemiBold = 'Konnect-SemiBold'
